import React from 'react';
import I18n from 'i18n-js';
import { debounce } from 'lodash';
import URLHelpers from '../shared/url_helpers';

import RouterHistory from '@reverbdotcom/commons/src/cms/lib/router_history';
import { RCCloseButton } from '@reverbdotcom/cadence/components';

interface IProps {
  initialValue?: string;
  submitPath?: ({ query }?: { query?: any; }) => string;
  placeholder?: string;
}

const performDebouncedSearch = debounce(pushQueryToUrl, 200);

function pushQueryToUrl(inputValue, props) {
  const params: { query: string } = { query: inputValue };

  let submitPath = URLHelpers.sellFormSearchPath(params);

  if (props.submitPath) {
    submitPath = props.submitPath(params);
  }

  return RouterHistory.push(submitPath);
}

export function CSPSearchInputV2(props: IProps) {
  const [query, setQuery] = React.useState(props.initialValue);
  const searchInputEl = React.useRef(null);

  React.useEffect(() => {
    setQuery(props.initialValue);
  }, [props.initialValue]);

  const updateGrid = (inputValue, props) => {
    performDebouncedSearch(inputValue, props);
  };

  const hasQuery = () => (query && query.length > 0);

  const handleChange = (evt) => {
    const inputValue = evt.target.value;
    setQuery(inputValue);
    updateGrid(inputValue, props);
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();

    if (query) {
      pushQueryToUrl(query, props);
    }
  };

  const handleQueryClearButtonClick = () => {
    setQuery('');
    pushQueryToUrl('', props);
    searchInputEl.current.focus();
  };

  return (
    <div className="csp-search-input-v2">
      <form
        role="search"
        className="csp-search-input-v2__form"
        action={window.location.pathname}
        onSubmit={handleSubmit}
      >
        <div className="csp-search-input-v2__form__input">
          <div className="input-group">
            <div className="csp-search-input-v2__form__input__search">
              <input className="input-group__input"
                autoCapitalize="off"
                autoComplete="off"
                autoCorrect="off"
                name="csp_search"
                onChange={handleChange}
                placeholder={props.placeholder}
                spellCheck={false}
                type="search"
                value={query}
                aria-label={I18n.t('discovery.sellFlow.search.label')}
                ref={searchInputEl}
              />
              {hasQuery() &&
                <span className="csp-search-input-v2__form__input__search__clear">
                  <RCCloseButton
                    onClick={handleQueryClearButtonClick}
                    aria-label={I18n.t('discovery.sellFlow.search.clearSearchQuery')}
                  />
                </span>
              }
            </div>
            <button
              className="csp-search-input-v2__form__input__search__button"
              type="submit"
              disabled={!hasQuery()}
            >
              {I18n.t('discovery.sellFlow.search.searchButton')}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
